/**
 * @file: 获取所有货架占用宽度
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import * as Toolkit from '../../toolkit';
import CodiSystem from '../../codiSystem/index';
import Utils from '../../utils/util';

function shelfTotalWidth(): LogicsicsMeasurement {
    let result: LogicsicsMeasurement = 0;
    let cubes: CubeId[] = CubeTree.getCubeByType('shelf');

    cubes.forEach((shelf: CubeId): void => {
        let shelfCodi: LogicCoordinate|null = CodiSystem.getLogicCoordinate(shelf);

        if (!shelfCodi) {
            return;
        }

        result = Utils.math(result, shelfCodi.width, '+');
    });

    return result;
}

function shelfPaintTotalWidth(): LogicsicsMeasurement {
    let result: LogicsicsMeasurement = 0;
    let cubes: CubeId[] = CubeTree.getCubeByType('shelf');

    cubes.forEach((shelf: CubeId): void => {
        let shelfCodi: PaintCoordinate|null = CodiSystem.getPaintCoordinate(shelf);

        if (!shelfCodi) {
            return;
        }

        result = Utils.math(result, shelfCodi.width, '+');
    });

    return result;
}

function shelfsPaintMaxHeight(): LogicsicsMeasurement {
    let result: LogicsicsMeasurement = 0;
    let cubes: CubeId[] = CubeTree.getCubeByType('shelf');

    cubes.forEach((shelf: CubeId): void => {
        let shelfCodi: PaintCoordinate|null = CodiSystem.getPaintCoordinate(shelf);

        if (!shelfCodi) {
            return;
        }

        result = Math.max(result, shelfCodi.height);
    });

    return result;
}

function shelfsMaxLogicHeight(): LogicsicsMeasurement {
    let shelfAreaHeight: PhysicsMeasurement = CodiSystem.sketchpadPhysicsHeight();

    return Toolkit.cmToPx(shelfAreaHeight);
}

export {
    shelfTotalWidth,
    shelfPaintTotalWidth,
    shelfsPaintMaxHeight,
    shelfsMaxLogicHeight
};
